import React from 'react';

class ImgWithFallback extends React.Component {

    static defaultProps = {
        fallback: (
            <div className="media-object" />
        )
    };

    state = {
        error: false
    };

    onError = () => {
        this.setState({ error: true });
    };

    render() {

        if (this.state.error || !this.props.src) {
            return this.props.fallback;
        }

        return (
            <img {...this.props} onError={this.onError} />
        );
    }
}

export default ImgWithFallback;


// WEBPACK FOOTER //
// ./src/components/_global/ImgWithFallback.jsx